<template>
    <el-dialog :visible.sync="show"
        :title="$t('slb.operations.delete.name')"
        :close-on-click-modal="false"
        :before-close="handleClose"
        width="30%">
        <p>{{ $t('slb.sentence.deleteStrategyTip')}}</p>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelDelete">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="sureDelete" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'DeleteStrategy',
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        listenerId: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        },
        currentStrategy: {
            type: Object,
        }
    },
    data() {
        return {
            show: this.dialogVisible
        };
    },
    watch: {
        dialogVisible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:dialogVisible', false);
        },
        cancelDelete() {
            this.handleClose();
        },
        sureDelete() {
            const params = {
                region: this.region,
                listenerId: this.listenerId,
                ruleId: this.currentStrategy.ruleId
            };
            Ajax.del('/api/cps/listenerAcl', params)
            .then((res) => {
                if (res.data && res.data.success) {
                    this.$message.success(this.$t('subnet.text.operationSuccess'));
                    this.$emit('deleteStrategyComplete');
                }
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
            });
        }
    },
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/slb/deleteStrategy.vue